const Button = ({
  children,
  onClick,
  height,
  width,
  type = 'button',
  className = '',
  ...rest
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      style={{
        height: height,
        width: width,
      }}
      className={`bg-[#12F280] rounded-full text-black px-6 py-2 text-[16px] hover:bg-green-300 transition ${className}`}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;